import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import client from '../../../client';
import { useMessage } from 'app/shared-components/MessageUtils';
import { useTranslation } from 'react-i18next';

const ModalAdjustmentTransactionMessage = ({ open, setOpen, validationResponse, formData, onSuccess }) => {
  const { t } = useTranslation('navigation');
  const showMessageUtil = useMessage();
  const [loading, setLoading] = useState(false);

  const handleProceed = async () => {
    setLoading(true);
    try {
      console.log('Proceeding with adjustment transaction:', formData);
      await client.post('/fuel-inventory/add-adjustment-transaction/', { ...formData });
      
      showMessageUtil(t('ADJUSTMENT_TRANSACTION_SUCCESS') || 'Adjustment transaction added successfully', 'success');
      
      if (onSuccess) onSuccess();
      setOpen(false);
    } catch (err) {
      let errorMessage = t('ERROR_ADDING_ADJUSTMENT_TRANSACTION') || 'Error adding adjustment transaction';
      
      if (err.response && err.response.data) {
        if (err.response.data.message) {
          errorMessage = err.response.data.message;
        } else if (err.response.data.error) {
          errorMessage = err.response.data.error;
        } else if (typeof err.response.data === 'string') {
          errorMessage = err.response.data;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      showMessageUtil(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (    
    <Dialog 
      open={open} 
      onClose={handleCancel}
      PaperProps={{
        sx: {
          width: '600px',
          maxWidth: '600px'
        }
      }}
    >
      <DialogTitle>{t('ADJUSTMENT_TRANSACTION_CONFIRMATION') || 'Adjustment Transaction Confirmation'}</DialogTitle>

      {validationResponse?.adjustment_type === 'decrease' && (
        <>
          <DialogContent>
            <Box sx={{ mt: 2 }}>
              {validationResponse && (
                <div>
                  {validationResponse.message && (
                    <p style={{ fontSize: '16px', marginBottom: '16px' }}>
                      {validationResponse.message}
                    </p>
                  )}
                  {validationResponse.data && (
                    <pre style={{ 
                      backgroundColor: '#f5f5f5', 
                      padding: '16px', 
                      borderRadius: '8px',
                      overflow: 'auto',
                      fontSize: '14px',
                      fontFamily: 'poppins'
                    }}>
                      <p>
                        This Adjustment Transaction will modify the following Batches:
                        <br />
                        <br />
                        {validationResponse.data.map((batch) => (
                          <>
                            <b>Batch ID</b>: {batch.batch_id}
                            <br />
                            <b>Quantity to Substract</b>: {batch.quantity_to_substract}
                            <br />
                            <b>Quantity Left</b>: {batch.quantity_left}
                            <br />
                            <br />
                          </>
                        ))}
                        <br />
                        <b>Total Quantity Adjusted:</b> {validationResponse.data.reduce((acc, batch) => acc + batch.quantity_to_substract, 0)}
                      </p>
                    </pre>
                  )}
                </div>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} disabled={loading}>
              {t('CANCEL') || 'Cancel'}
            </Button>
            <Button 
              onClick={handleProceed} 
              variant="contained" 
              color="primary"
              disabled={loading}
            >
              {loading ? (t('PROCESSING') || 'Processing...') : (t('PROCEED') || 'Proceed')}
            </Button>
          </DialogActions>
        </>
      )}

{validationResponse?.adjustment_type === 'increase' && (
        <>
          <DialogContent>
            <Box sx={{ mt: 2 }}>
              {validationResponse && (
                <div>
                  <b style={{ fontSize: '16px', marginBottom: '16px' }}>This adjustment will free up space in your inventory by reducing the amount consumed in each transaction. The reduction will be applied to the entire batch, and transactions that undergo a reduction cannot be edited.</b>
                  <br />
                  <br />
                  {validationResponse.message && (
                    <p style={{ fontSize: '16px', marginBottom: '16px' }}>
                      {validationResponse.message}
                    </p>
                  )}
                  {validationResponse.data && (
                    <pre style={{ 
                      backgroundColor: '#f5f5f5', 
                      padding: '16px', 
                      borderRadius: '8px',
                      overflow: 'auto',
                      fontSize: '14px',
                      fontFamily: 'poppins'
                    }}>
                      <p>
                        This Adjustment Transaction will modify the following Transactions:
                        <br />
                        <br />
                        {[...validationResponse.data].map((batch) => (
                          <>
                            <b>Transaction ID</b>: {batch.transaction_id}
                            <br />
                            <b>Batch ID</b>: {batch.batch_id}
                            <br />
                            <b>Original Quantity</b>: {batch.original_quantity}
                            <br />
                            <b>Reduction Applied</b>: {batch.reduction_quantity}
                            <br />
                            <b>Remainig Quantity</b>: {batch.remaining_quantity}
                            <br />
                            <br />
                          </>
                        ))}
                        <br />
                        <b>Total Quantity Adjusted:</b> {validationResponse.data.reduce((acc, batch) => acc + batch.reduction_quantity, 0)}
                      </p>
                    </pre>
                  )}
                </div>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} disabled={loading}>
              {t('CANCEL') || 'Cancel'}
            </Button>
            <Button 
              onClick={handleProceed} 
              variant="contained" 
              color="primary"
              disabled={loading}
            >
              {loading ? (t('PROCESSING') || 'Processing...') : (t('PROCEED') || 'Proceed')}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalAdjustmentTransactionMessage;

